import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as moment from 'moment-timezone';

import { User } from '../user';

@Component({
  selector: 't-user-details',
  templateUrl: './details.component.html',
})
export class UserDetailsComponent implements OnInit {

  @Input()
  user: User

  firstname: FormControl
  lastname: FormControl

  timezones = moment.tz.names()

  active: any

  ngOnInit() {
    this.active = [{
      id: this.user.timezone,
      text: this.user.timezone
    }];

    // firstname
    this.firstname = new FormControl(this.user.firstname, [
      Validators.required,
    ]);

    this.firstname.valueChanges.subscribe((value) => {
      this.user.firstname = value;
    });

    // lastname
    this.lastname = new FormControl(this.user.lastname, [
      Validators.required,
    ]);

    this.lastname.valueChanges.subscribe((value) => {
      this.user.lastname = value;
    });
  }

  selected(event: any) {
    this.user.timezone = event.id;
  }
}
